export var getQueryValue = function getQueryValue(query) {
  if (!query) return [];
  return Array.isArray(query) ? query : [query];
};